/**
 * Created by fers on 20.01.16.
 */

import channelType from './ChannelType';
import relationDefType from './RelationDefType';
import customDataType from './CustomDataType';
import fetchType from './FetchType';
import fetchStatsType from './FetchStatsType';
import jobType from './JobType';
import jobTaskType from './JobTaskType';
import warningLogType from './WarningLogType';
import channelAddonType from './ChannelAddonType';
import loggerType from './LoggerType';
import runningJobType from './RunningJobType';
import databaseType from './DatabaseType';
import dataStatsType from './DataStatsType';

import announcementsType from './AnnouncementsType.js';
import announcementReadsType from './AnnouncementReadsType.js';

import organisationType from './OrganisationType';
import organisationAddonType from './OrganisationAddonType';
import organisationEventType from './OrganisationEventType';
import organisationStatisticsType from './OrganisationStatisticsType';
import organisationNotificationType from './OrganisationNotificationType';
import tariffType from './TariffType';
import usedScenarioType from './UsedScenarioType';
import usedScenarioWithScreenDefs from './UsedScenarioWithScreenDefType';
import eventListenerStateType from './EventListenerStateType';
import storeInfoType from './StoreInfoType';
import storeDetailType from './StoreDetailType';
import flowType from './FlowType';
import flowIncomingEmailType from './FlowIncomingEmailType';
import flowInvocationType from './FlowInvocationType';
import billingItemType from './BillingItemType';
import billingRuleType from './BillingRuleType';

import channelErrorType from './ChannelErrorType';
import eventType from './EventType';
import eventDetectorType from './EventDetectorType';
import apiKeyType from './ApiKeyType';
import userType from './UserType';
import userIdentityType from './UserIdentityType';
import invitationType from './InvitationType';
import organisation2userType from './Organisation2UserType';
import hookType from './HookType';

import profileDefType from './ProfileDefType';
import profileItemDefType from './ProfileItemDefType';

import coordinationDefType from './CoordinationDefType';

import developerGroupType from './DeveloperGroupType';
import developerGroup2UserType from './DeveloperGroup2UserType';

import addonDefType from './AddonDefType';
import actionDefType from './ActionDefType';
import actionInputDefType from './ActionInputDefType';
import channelDefType from './ChannelDefType';
import channelDefVersionType from './ChannelDefVersionType';
import channelTypeConversionDefType from './ChannelTypeConversionDefType';
import channelScriptDefType from './ChannelScriptDefType';
import channelInjectionDefType from './ChannelInjectionDefType';
import channelErrorDefType from './ChannelErrorDefType';

import channelDefExclusionType from './ChannelDefExclusionType';
import channelURLDefType from './ChannelURLDefType';
import sourceDefType from './SourceDefType';
import operationDefType from './OperationDefType';
import sourceDefOperationDefType from './SourceDefOperationType';
import sourceGroupDefs from './SourceGroupDefType';
import channelOptionDefType from './ChannelOptionDefType';
import channelMappingDefType from './ChannelMappingDefType';
import channelMappingArgDefType from './ChannelMappingArgDefType';
import channelEntityDefType from './ChannelEntityDefType';
import channelFieldDefType from './ChannelFieldDefType';
import scenarioDefType from './ScenarioDefType';
import scenarioDefVersionType from './ScenarioDefVersionType';
import scenarioChannelDefRuleType from './ScenarioChannelDefRuleType';
import scenarioScreenDefType from './ScenarioScreenDefType';
import scenarioFlowDefType from './ScenarioFlowDefType';
import scenarioDefs2ChannelDefType from './ScenarioDefs2ChannelDefsType';
import scenarioType from './ScenarioType';
import scenarios2ChannelDefType from './Scenarios2ChannelDefsType';
import scenarios2SourceDefType from './Scenarios2SourceDefsType';

import channelRelationDefType from './ChannelRelationDefType';

import groupDefType from './GroupDefType';
import groupDefVersionType from './GroupDefVersionType';
import entityDefType from './EntityDefType';
import entityRelationDefType from './EntityRelationDefType';
import fieldDefType from './FieldDefType';
import computedFieldDefType from './ComputedFieldDefType';
import entityViewDefType from './EntityViewDefType';
import screenDefType from './ScreenDefType';

import screenType from './ScreenType';
import dataSetType from './DataSetType';
import viewWithDataType from './ViewWithDataType';
import screenBoxToAdd from './ScreenBoxToAddType';
import screenDataSourceToAdd from './ScreenDataSourceToAddType';

import manualRelationType from './ManualRelationType';

import libraryDefType from './LibraryDefType';
import libraryDefVersionType from './LibraryDefVersionType';
import flowChannelDefType from './FlowChannelDefType';
import flowDefType from './FlowDefType';
import flowDefDocsType from './FlowDefDocsType';
import flowDefVersionType from './FlowDefVersionType';
import flowExtensionLinkDefs from './FlowExtensionLinkDefType';
import flowCoordinationEventType from './FlowCoordinationEventType';
import flowCoordinationHookType from './FlowCoordinationHookType';
import flowStepDefType from './FlowStepDefType';
import flowStepConfigDefType from './FlowStepConfigDefType';
import flowStepLinkDefType from './FlowStepLinkDefType';
import flowOptionDefs from './FlowOptionDefType';
import flowOptionDocDefs from './FlowOptionDocDefType';
import flowOptionGroupDefs from './FlowOptionGroupDefType';
import flowScriptDefs from './FlowScriptDefType';
import flowBillingRules from './FlowBillingRuleType';

// Overdue bills (new entities)
import organisationOverdueBillType from './OrganisationOverdueBillType.js';
import organisationOverdueBillLogType from './OrganisationOverdueBillLogType.js';
import organisationOverdueBillCommunicationType from './OrganisationOverdueBillCommunicationType.js';
import organisationOverdueBillActionType from './OrganisationOverdueBillActionType.js';
import overdueBillsSettingType from './OverdueBillsSettingType.js';

import formType from './FormType';
import formFieldType from './FormFieldType';

import entityInheritanceDefType from './EntityInheritanceDefType';
import viewType from './ViewType';
import dataSourceType from './DataSourceType';
import entitySelectionRuleType from './EntitySelectionRuleType';

import instanceType from './InstanceType';
import instanceScenarioType from './InstanceScenarioType';

import {declareEntityList} from '../fw/MetaDataHelper.ts';

export default declareEntityList([
    organisationType,
    organisationEventType,
    organisationNotificationType,
    organisationAddonType,
    organisationStatisticsType,
    tariffType,
    // Overdue bills
    organisationOverdueBillType,
    organisationOverdueBillLogType,
    organisationOverdueBillCommunicationType,
    organisationOverdueBillActionType,
    overdueBillsSettingType,
    billingItemType,
    billingRuleType,
    invitationType,
    userType,
    apiKeyType,
    organisation2userType,
    userIdentityType,
    databaseType,
    dataStatsType,
    announcementsType,
    announcementReadsType,

    channelType,
    channelAddonType,
    screenType,
    screenBoxToAdd,
    screenDataSourceToAdd,
    viewType,
    dataSourceType,
    entitySelectionRuleType,
    relationDefType,
    dataSetType,
    viewWithDataType,
    usedScenarioType,
    usedScenarioWithScreenDefs,
    customDataType,
    channelErrorType,
    flowType,
    flowIncomingEmailType,
    flowInvocationType,

    storeInfoType,
    storeDetailType,
    eventListenerStateType,
    hookType,

    eventType, /* something streaming */
    fetchType, /* SQL */
    fetchStatsType, /* SQL */
    warningLogType, /* S3 */
    jobType, /* dynamicdb */
    jobTaskType, /* dynamicdb */
    eventDetectorType, /* sql */
    loggerType, /* elastic search */
    runningJobType,

    developerGroupType,
    developerGroup2UserType,
    instanceType,
    instanceScenarioType,

    profileItemDefType,
    profileDefType,

    libraryDefType,
    libraryDefVersionType,
    channelDefType,
    channelDefVersionType,
    coordinationDefType,
    actionDefType,
    channelTypeConversionDefType,
    channelScriptDefType,
    actionInputDefType,
    addonDefType,
    channelDefExclusionType,
    channelInjectionDefType,
    channelErrorDefType,
    sourceDefType,
    sourceDefOperationDefType,
    sourceGroupDefs,
    channelURLDefType,
    channelOptionDefType,
    channelMappingDefType,
    channelMappingArgDefType,
    channelEntityDefType,
    channelFieldDefType,
    channelRelationDefType,
    scenarioDefType,
    scenarioDefVersionType,
    scenarioFlowDefType,
    scenarioChannelDefRuleType,
    scenarioScreenDefType,
    scenarioDefs2ChannelDefType,
    scenarios2ChannelDefType,
    scenarios2SourceDefType,
    scenarioType,
    operationDefType,

    flowDefType,
    flowDefDocsType,
    flowDefVersionType,
    flowExtensionLinkDefs,
    flowChannelDefType,
    flowStepDefType,
    flowStepLinkDefType,
    flowStepConfigDefType,
    flowOptionDefs,
    flowOptionDocDefs,
    flowOptionGroupDefs,
    flowScriptDefs,
    flowCoordinationEventType,
    flowCoordinationHookType,
    flowBillingRules,

    formType,
    formFieldType,

    manualRelationType,

    groupDefType,
    groupDefVersionType,
    entityDefType,
    entityViewDefType,
    screenDefType,
    entityRelationDefType,
    fieldDefType,
    computedFieldDefType,
    entityInheritanceDefType
]);
